import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';

/**
 * A hook to invoke a given callback with a given interval.
 * setInterval does not work very well with React {@link https://overreacted.io/making-setinterval-declarative-with-react-hooks/}.
 * @param {function} callback - The callback function to be invoked.
 * @param {number} delay - The number of milliseconds in between callback invocations.
 */
export const useInterval = (callback: Function, delay: number | null) => {
  const savedCallback = useRef(callback);

  // Remember latest callback if it changes.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up interval.
  useEffect(() => {
    if (delay === null) {
      return;
    }

    const tick = () => {
      savedCallback.current();
    };

    const id = setInterval(tick, delay || 0);
    return () => {
      clearInterval(id);
    };
  }, [delay]);
};
